import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

const CustomDetailValue = ({
  description,
  children,
}: {
  description: string
  children?: React.ReactNode
}) =>
  children === undefined ? (
    <></>
  ) : (
    <Box minWidth="s240" flexNoShrink textAlign="left" gap="s8">
      <Text weight="medium" size="300" color="grey1000">
        {description}
      </Text>
      <Box height="s24">{children}</Box>
    </Box>
  )

export interface CustomPairTransactionDetailsProps {
  desc1: string
  desc2: string
  val1?: React.ReactNode
  val2?: React.ReactNode
}

export const CustomPairTransactionDetails = ({
  desc1,
  desc2,
  val1,
  val2,
}: CustomPairTransactionDetailsProps) => (
  <Box
    width="full"
    flexDirection="row"
    justifyContent="flexStart"
    alignItems="flexStart"
    flexWrap="wrap"
    gap="s32"
  >
    {desc1 && val1 && <CustomDetailValue description={desc1}>{val1}</CustomDetailValue>}
    {desc2 && val2 && <CustomDetailValue description={desc2}>{val2}</CustomDetailValue>}
  </Box>
)
